import type { IntlShape } from 'react-intl';
import { matchPath } from 'react-router-dom-v5-compat';

import { RoutePathType } from '~/routing/enums';
import { Routes } from '~/routing/types';

import { publicRoutes, reservedRoutePaths } from './routes';

/** Trims leading and trailing / */
export const trimSlashes = (path: string) =>
  path === '/' ? path : path.replace(/^\/+|\/+$/g, '');

/** Tests that a path is a public path */
export const testIsPublicPath = (path: string, intl: IntlShape) =>
  Object.values(publicRoutes(intl)).some((route) => {
    return trimSlashes(path).includes(trimSlashes(route.path));
  });

export const testIsReservedPath = (path: string, intl: IntlShape) =>
  testIsPublicPath(path, intl) ||
  reservedRoutePaths(intl)
    .map(trimSlashes)
    .includes(trimSlashes(path) as RoutePathType);

export const findMatchingRoute = (routes: Routes, pathname: string) => {
  for (const [routePath, route] of Object.entries(routes)) {
    const exactMatch = matchPath(routePath, pathname);
    if (exactMatch) {
      return route;
    }

    // If no exact match and route has nested children, check them
    if (route.nestedRoutes) {
      const parentMatch = matchPath({ path: routePath, end: false }, pathname);

      if (parentMatch) {
        for (const nested of route.nestedRoutes) {
          const fullNestedPath = `${routePath}/${nested.path}`;
          const nestedMatch = matchPath(fullNestedPath, pathname);

          if (nestedMatch) {
            return nested;
          }
        }
      }
    }
  }

  return null;
};
